import { z } from '../zod.js';
import { IsoTimestamp, ReleaseId } from './common.js';
export const QuietWindow = z
    .strictObject({
    start: IsoTimestamp,
    end: IsoTimestamp,
    label: z.string().max(200).optional(),
})
    .refine((w) => Date.parse(w.end) >= Date.parse(w.start), {
    message: 'a window cannot end before it starts',
    path: ['end'],
});
/**
 * `/home/dnd/dnd-app-v4/.data/status/quiet.json`: written by `codex-web` (P0-2), read by
 * `run-guarded.sh` (P0-12) and `scripts/deploy.sh` (P0-10). Timestamps are ISO 8601 UTC.
 */
export const QuietStatusV1 = z.strictObject({
    version: z.literal(1),
    writtenAt: IsoTimestamp,
    release: ReleaseId,
    sessionRunning: z.boolean(),
    windows: z.array(QuietWindow),
});
//# sourceMappingURL=quiet.js.map